import { useState } from "react";

import chaseLogo from "@/assets/bank-logos/chase-bank-logo.svg";
import boaLogo from "@/assets/bank-logos/bank-of-america-logo.svg";
import wellsFargoLogo from "@/assets/bank-logos/wells-fargo-logo.svg";
import capitalOneLogo from "@/assets/bank-logos/capital-one-logo.svg";
import citiLogo from "@/assets/bank-logos/citi-bank-logo.svg";

import chaseSymbol from "@/assets/bank-logos/chase-bank-symbol.svg";
import boaSymbol from "@/assets/bank-logos/bank-of-america-symbol.svg";
import wellsFargoSymbol from "@/assets/bank-logos/wells-fargo-symbol.svg";
import capitalOneSymbol from "@/assets/bank-logos/capital-one-symbol.svg";
import citiSymbol from "@/assets/bank-logos/citi-bank-symbol.jpeg";

type BankKey = "chase" | "bankofamerica" | "wellsfargo" | "capitalone" | "citi";

const localLogos: Record<BankKey, { logo: string; symbol: string }> = {
  chase: { logo: chaseLogo, symbol: chaseSymbol },
  bankofamerica: { logo: boaLogo, symbol: boaSymbol },
  wellsfargo: { logo: wellsFargoLogo, symbol: wellsFargoSymbol },
  capitalone: { logo: capitalOneLogo, symbol: capitalOneSymbol },
  citi: { logo: citiLogo, symbol: citiSymbol },
};

const domainToKey: Record<string, BankKey> = {
  "chase.com": "chase",
  "bankofamerica.com": "bankofamerica",
  "wellsfargo.com": "wellsfargo",
  "capitalone.com": "capitalone",
  "citi.com": "citi",
};

interface BankLogoProps {
  name: string;
  domain: string;
  color: string;
  size?: number;
  variant?: "logo" | "symbol";
}

export function BankLogo({ name, domain, color, size = 48, variant = "logo" }: BankLogoProps) {
  const [failed, setFailed] = useState(false);
  const initials = name.split(" ").map(w => w[0]).join("").slice(0, 2);

  const key = domainToKey[domain];
  const local = key ? localLogos[key] : undefined;
  const src = local ? local[variant] : undefined;

  if (!src || failed) {
    return (
      <div
        className="w-full h-full rounded-lg flex items-center justify-center"
        style={{ backgroundColor: color }}
      >
        <span className="text-white font-bold" style={{ fontSize: size * 0.32 }}>
          {initials}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      width={size}
      height={size}
      className="object-contain"
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
